export enum PublicationId {
    ProductNews = 'pei recent news publication',
    PrivateEquityInsights = 'private equity insights publication',
    ResearchPapers = 'pei research papers publication',
    Trends = 'pci trends publication'
}

export const PublicationsMap: Record<string, string> = {
    'pei recent news publication': 'news',
    'pci trends publication': 'news',
    'private equity insights publication': 'publications',
    'pei research papers publication': 'publications'
};

export interface Publication {
    id?: string;
    name?: string;
}

export interface Article {
    id?: string;
    title?: string;
    abstractHtml?: string;
    blurb?: string;
    publishDate?: number;
    publishDateStr?: string;
    publication?: Publication;
    authors?: string[];
    pdf?: { id?: string };
    image?: { id?: string };
    paperLink?: string;
    seo?: {
        title?: string;
        keywords?: string;
        description?: string;
        image?: {
            id?: string;
            name?: string;
            type?: string;
        };
    };
}

// Rolling Return related types and enums
export interface SelectModel {
    id: string;
    name: string;
}

export interface IRollingReturnData {
    [key: string]: {
        [strategy: string]: {
            [quarter: string]: number;
        };
    };
}

export interface IRollingReturnParams {
    investmentHorizons?: SelectModel[];
    selectedInvestmentHorizonId?: string;
    chartData?: any[] | null;
    gridData?: any;
    metadata?: any;
}

export interface PreliminaryIrrModel {
    runDate?: string;
    data?: {
        [key: string]: number;
    };
    enabled?: boolean;
}

export interface PreliminaryIrrResponse {
    result?: PreliminaryIrrModel;
}

export interface HorizonReturnsResponse {
    headers?: string[];
    data?: (string | number)[][];
    description?: string;
    title?: string;
    metadata?: { reportdate?: string; tradequarter?: string };
}

export interface SubtitlesResponse {
    results?: string[];
}

export const StrategyValue = {
    bo: 'Buyout',
    vc: 'Venture Capital',
    debt: 'Private Debt'
} as const;

export const CHART_COLORS = {
    buyoutColor: '#3C66AA',
    ventureCapitalColor: '#679000',
    privateDebtColor: '#E28100',
    blackColor: '#000000'
} as const;

// Utility functions
export const naToNull = (value: any): number | null => {
    if (!value || isNaN(value) || !isFinite(value)) {
        return null;
    }
    return value;
};

export const toRolling = (value: any, decimals: number): number => {
    if (!value || isNaN(value) || !isFinite(value)) {
        return 0;
    }
    return decimals ? Number(Number(value).toFixed(decimals)) : value;
};

export type HttpResult<T> = Partial<{
    data: T;
    error: any;
}>;

export type Seo = Partial<{
    type: string;
    title: string;
    url: string;
    description: string;
    keywords: string;
    imageUrl: string;
    imageWidth: number;
    imageHeight: number;
}>;
